/**
 * Collection editorial product cards:
 *   Desktop — stacked images + hover cycle (no change).
 *   Mobile  — Embla carousel with loop, dots, arrows.
 */
(function () {
  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function parseIntAttr(el, name, fallback) {
    if (!el || typeof el.getAttribute !== 'function') return fallback;
    const v = parseInt(el.getAttribute(name), 10);
    return Number.isFinite(v) ? v : fallback;
  }

  /* ── Desktop hover image cycle ──────────────────────────────────────── */

  function setupImageCycle(mediaEl) {
    const card = mediaEl.closest('.card-collection-editorial');
    const hoverDelayMs = parseIntAttr(card, 'data-image-cycle-delay', 1500);
    const cycleIntervalMs = parseIntAttr(card, 'data-image-cycle-speed', 1500);

    let hoverTimeout = null;
    let cycleInterval = null;
    const images = mediaEl.querySelectorAll('.card-collection-editorial__img');
    const total = images.length;

    if (total < 2 || REDUCED_MOTION) return;

    const showImage = (index) => {
      images.forEach((img, i) => img.classList.toggle('image--active', i === index));
    };

    const startCycle = () => {
      let currentIndex = 1;
      showImage(currentIndex);
      cycleInterval = setInterval(() => {
        currentIndex = (currentIndex + 1) % total;
        showImage(currentIndex);
      }, cycleIntervalMs);
    };

    const stopCycle = () => {
      if (hoverTimeout) { clearTimeout(hoverTimeout); hoverTimeout = null; }
      if (cycleInterval) { clearInterval(cycleInterval); cycleInterval = null; }
      showImage(0);
    };

    mediaEl.addEventListener('mouseenter', () => {
      stopCycle();
      if (hoverDelayMs <= 0) { startCycle(); }
      else { hoverTimeout = setTimeout(startCycle, hoverDelayMs); }
    });

    mediaEl.addEventListener('mouseleave', () => stopCycle());
  }

  /* ── Mobile Embla carousel ──────────────────────────────────────────── */

  function setupMobileEmbla(card) {
    const viewport = card.querySelector('[data-editorial-viewport]');
    if (!viewport) return;

    const dotRoot = card.querySelector('[data-editorial-dots]');
    const dots = dotRoot ? Array.from(dotRoot.querySelectorAll('.card-collection-editorial__dot')) : [];
    const prevBtn = card.querySelector('[data-editorial-prev]');
    const nextBtn = card.querySelector('[data-editorial-next]');

    const syncDots = (embla) => {
      const selected = embla.selectedScrollSnap();
      dots.forEach((d, j) => d.classList.toggle('is-active', j === selected));
    };

    const embla = EmblaCarousel(viewport, { loop: true, draggable: true });

    syncDots(embla);
    embla.on('select', () => syncDots(embla));

    dots.forEach((dot) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        const idx = parseInt(dot.getAttribute('data-dot-index'), 10);
        if (Number.isFinite(idx)) embla.scrollTo(idx);
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', (e) => { e.preventDefault(); embla.scrollPrev(); });
    if (nextBtn) nextBtn.addEventListener('click', (e) => { e.preventDefault(); embla.scrollNext(); });
  }

  /* ── Embla loader ───────────────────────────────────────────────────── */

  let emblaLoading = false;
  const emblaQueue = [];

  function withEmbla(callback) {
    if (typeof EmblaCarousel !== 'undefined') {
      callback();
      return;
    }
    emblaQueue.push(callback);
    if (emblaLoading) return;
    emblaLoading = true;
    const script = document.createElement('script');
    script.src = 'https://unpkg.com/embla-carousel@8/embla-carousel.umd.js';
    script.onload = () => {
      emblaLoading = false;
      while (emblaQueue.length) emblaQueue.shift()();
    };
    document.head.appendChild(script);
  }

  /* ── Init ────────────────────────────────────────────────────────────── */

  function initCard(card) {
    const cycleMedia = card.querySelector('.card-collection-editorial__media-inner.media--image-cycle');
    if (cycleMedia) setupImageCycle(cycleMedia);

    const viewport = card.querySelector('[data-editorial-viewport]');
    if (viewport) withEmbla(() => setupMobileEmbla(card));
  }

  function init() {
    const grid = document.getElementById('product-grid');
    if (!grid || !grid.classList.contains('product-grid--editorial')) return;
    grid.querySelectorAll('.card-collection-editorial').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
